import { Tag } from 'primereact/tag';
import { InputTextarea } from 'primereact/inputtextarea';
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { DocFeedback } from '../../../../../api/types/docs/doc-feedback';
import { updateDocFeedbackStatusOperations } from './operations/update-doc-feedback-status-operations';
import { DocFeedbackStatusDB } from '../../../../../api/types/docs/doc-feedback-status';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';
import { DocDetails } from '../../../../../api/types/docs/doc-details';

interface DocFeedbackItemModel {
  feedback: DocFeedback;
  userId: number;
  user: UserSummaryType;
  index: number;
  isLast: boolean;
  isRejectItem: boolean;
  setDocs: (docs: DocDetails[]) => any;
  updateDocFeedbackOperation?: (
    userId: number,
    user: UserSummaryType,
    dockId: number,
    feedbackId: number,
    status: DocFeedbackStatusDB,
    setDocs: (docs: DocDetails[]) => any,
    setLoading: (loading: boolean) => any,
  ) => any;
  isAdminModeActive: boolean;
}
export const DocFeedbackItem: React.FC<DocFeedbackItemModel> = ({
  feedback,
  userId,
  user,
  index,
  isLast,
  isRejectItem,
  setDocs,
  updateDocFeedbackOperation,
  isAdminModeActive,
}) => {
  const [checked, setChecked] = useState(false);

  const [value, setValue] = useState(feedback.content);
  const [isReject, setIsReject] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleUpdateFeedbackStatus = async (status: DocFeedbackStatusDB) => {
    await (updateDocFeedbackOperation || updateDocFeedbackStatusOperations)(
      userId,
      user,
      feedback.docId,
      feedback.id,
      status,
      setDocs,
      setLoading,
    );
  };

  const handleDownloadFile = () => {
    if (feedback.fileUrl) {
      const link = document.createElement('a');
      link.href = feedback.fileUrl;
      link.download = '';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const getTag = () => {
    switch (feedback.status) {
      case DocFeedbackStatusDB.Approved:
        return <Tag severity={'success'} value={'אושר'} />;
      case DocFeedbackStatusDB.Init:
        return <Tag severity={'warning'} value={'ממתין לאישור'} />;
      case DocFeedbackStatusDB.Reject:
        return <Tag severity={'danger'} value={'נדחה'} />;
    }
  };

  return (
    <div style={{ marginRight: '8px', marginBottom: '16px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: '28px',
            justifyContent: 'space-between',
            marginBottom: '8px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {isLast && getTag()}
            <div style={{ marginRight: '4px' }}>מספר {index}</div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'left',
              marginBottom: '8px',
            }}
          >
            {/*<div>עריכה</div>
            <InputSwitch
              checked={checked}
              onChange={(e) => setChecked(e.value)}
              style={{ marginRight: '4px' }}
            />*/}

            <Button
              label="הורד קובץ"
              icon="pi pi-download"
              severity={'secondary'}
              style={{ height: '30px' }}
              onClick={handleDownloadFile}
              disabled={!feedback.fileUrl}
            />
          </div>
        </div>

        <InputTextarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          rows={5}
          cols={30}
          disabled={true}
          style={{ marginBottom: '8px', height: '75px' }}
        />
      </div>
      {checked && (
        <div>
          <Button
            style={{ height: '30px', fontSize: '14px' }}
            severity={'secondary'}
            outlined={true}
            label={'איפוס'}
          />

          <Button
            style={{ height: '30px', fontSize: '14px', marginRight: '8px' }}
            outlined={false}
            disabled={!checked}
            label={'אישור'}
          />
        </div>
      )}

      {isAdminModeActive && isLast && (
        <div>
          <Button
            style={{ height: '30px', fontSize: '14px' }}
            severity={'warning'}
            outlined={true}
            label={'דחייה'}
            disabled={feedback.status === DocFeedbackStatusDB.Reject}
            loading={loading}
            onClick={() =>
              handleUpdateFeedbackStatus(DocFeedbackStatusDB.Reject)
            }
            tooltip={
              feedback.status === DocFeedbackStatusDB.Reject
                ? 'לא ניתן לדחות מסמך שנדחה'
                : 'כפתור זה ידחה את המסמך'
            }
            tooltipOptions={{ showOnDisabled: true }}
          />

          <Button
            style={{ height: '30px', fontSize: '14px', marginRight: '8px' }}
            label={'אישור מסמך'}
            disabled={feedback.status === DocFeedbackStatusDB.Approved}
            loading={loading}
            onClick={() =>
              handleUpdateFeedbackStatus(DocFeedbackStatusDB.Approved)
            }
            tooltip={
              feedback.status === DocFeedbackStatusDB.Approved
                ? 'לא ניתן לאשר מסמך שאושר'
                : 'כפתור זה יאשר את המסמך'
            }
            tooltipOptions={{ showOnDisabled: true }}
          />
        </div>
      )}

      {isReject && (
        <DocFeedbackItem
          feedback={feedback}
          isLast={false}
          isAdminModeActive={true}
        />
      )}
    </div>
  );
};
